exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1P9j9iBZfEs5hIPwu9vfW5 ._32uk6BsiAbF8UPkHWiu9Kn{display:flex}._1P9j9iBZfEs5hIPwu9vfW5 ._muGk0Wrv2h6iINRul1a-{flex:1;margin-right:40px}._1P9j9iBZfEs5hIPwu9vfW5 ._1kZ_0WyFcaikr-2-Etpsed{flex:1}\n", ""]);

// Exports
exports.locals = {
	"EditTRouteModal": "_1P9j9iBZfEs5hIPwu9vfW5",
	"cols": "_32uk6BsiAbF8UPkHWiu9Kn",
	"col1": "_muGk0Wrv2h6iINRul1a-",
	"col2": "_1kZ_0WyFcaikr-2-Etpsed"
};